/**
 * @generated SignedSource<<768a662c455699b94f7b0c9ec4208cd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type eventRecurringPersistentDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  recurrenceID: string;
};
export type eventRecurringPersistentDeleteMutation$data = {
  readonly deleteRecurringEventPersistent: {
    readonly id: string;
  };
};
export type eventRecurringPersistentDeleteMutation = {
  variables: eventRecurringPersistentDeleteMutation$variables;
  response: eventRecurringPersistentDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recurrenceID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "recurrenceID",
    "variableName": "recurrenceID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventRecurringPersistentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventDeletePayload",
        "kind": "LinkedField",
        "name": "deleteRecurringEventPersistent",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventRecurringPersistentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventDeletePayload",
        "kind": "LinkedField",
        "name": "deleteRecurringEventPersistent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f7b223e0c5c706a48ddd21b7269f76d",
    "id": null,
    "metadata": {},
    "name": "eventRecurringPersistentDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation eventRecurringPersistentDeleteMutation(\n  $id: ID!\n  $recurrenceID: String!\n) {\n  deleteRecurringEventPersistent(id: $id, recurrenceID: $recurrenceID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc50a1860796112baddb4a6035646381";

export default node;
